import { createFileRoute } from '@tanstack/react-router';
import { AddCollectionPage } from '@/features/collections/pages/AddCollectionPage';

export const Route = createFileRoute('/_authenticated/collections/add')({
  component: AddCollectionPage,
});
